import { KOREA, SPAIN, FRANCE, USA, PORTUGAL, GERMANY, ITALY, POLAND, CHINA } from 'src/assets/images'

export const languages = [
  { value: 'es', src: SPAIN, alt: 'Spain', label: 'Español' },
  { value: 'en', src: USA, alt: 'United States', label: 'English' },
  { value: 'fr', src: FRANCE, alt: 'France', label: 'Français' },
  { value: 'ko', src: KOREA, alt: 'Korea', label: '한국인' },
  { value: 'pt', src: PORTUGAL, alt: 'Portugal', label: 'Português' },
  { value: 'de', src: GERMANY, alt: 'Germany', label: 'Deutsch' },
  { value: 'it', src: ITALY, alt: 'Italy', label: 'Italiano' },
  { value: 'pl', src: POLAND, alt: 'Polish', label: 'Polski' },
  { value: 'zh', src: CHINA, alt: 'Chineese', label: '中国人s' },
]
